// extracted by mini-css-extract-plugin
export default {"container":"style_container__-DSgo","btnDiv":"style_btnDiv__PtQg9"};